import { render, staticRenderFns } from "./list_paket_soal.vue?vue&type=template&id=28b18800&scoped=true&"
import script from "./list_paket_soal.vue?vue&type=script&lang=js&"
export * from "./list_paket_soal.vue?vue&type=script&lang=js&"
import style0 from "./list_paket_soal.vue?vue&type=style&index=0&id=28b18800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b18800",
  null
  
)

export default component.exports